import { render, staticRenderFns } from "./ListaVidas.vue?vue&type=template&id=2b786bd4&"
import script from "./ListaVidas.vue?vue&type=script&lang=js&"
export * from "./ListaVidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports